/**
 * A ValueError is thrown when the type of an argument is correct but the value
 * of it is incorrect.
 */
export class ValueError extends Error {
    constructor(message?: string) {
        super(message);

        // Maintains proper stack trace for where our error was thrown (only
        // available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ValueError);
        }

        this.name = 'ValueError';
    }
}
